var $462430bc9d088814$exports = {};
$462430bc9d088814$exports = {
    "invalidSelection": (args, formatter)=>`\u{9009}\u{5B9A}\u{7684} ${formatter.plural(args.selectedCount, {
            one: `\u{4E2A}\u{65E5}\u{671F}`,
            other: `\u{4E2A}\u{65E5}\u{671F}`
        })} \u{4E0D}\u{53EF}\u{7528}\u{3002}`
};


export {$462430bc9d088814$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
